<template>
  <div class="list-main" :style="listStyleObj">
    <div class="list-title singleline" v-if="listData.title"> {{ listData.title }} </div>
    <div class="list-title" v-else-if="listData.type === 1 || listData.type === 2" ><span class="live"></span></div>
    <div
      class="list-slider"
      :class="listClass"
      :style="computedStyleObject"
      ref="list"
    >
      <span v-for="(cardData, index) in listData.list" class="card" ref="card" :key="`card_${index}`">
        <home-live-card
          :cardData="cardData"
          :isFocusedLine="isFocusOn"
          :contentType="listData.type"
          v-if="isLiveVod"
        ></home-live-card>
        <home-vod-card
          :cardData="cardData"
          :isFocusedLine="isFocusOn"
          :contentType="listData.type"
          v-else-if="listData.cardType == 'HOME'"
        ></home-vod-card>
        <league-card
          :cardData="cardData"
          :isFocusedLine="isFocusOn"
          v-else-if="listData.cardType == 'LEAGUE'"
        ></league-card>
        <program-card
          :cardData="cardData"
          :isFocusedLine="isFocusOn"
          v-else-if="listData.cardType == 'PROGRAM'"
        ></program-card>
        <setting-card
          :cardData="cardData"
          :isFocusedLine="isFocusOn"
          v-else-if="listData.cardType == 'BUTTON'"
        ></setting-card>
        <league-detail-card
          :cardData="cardData"
          :isFocusedLine="isFocusOn"
          v-else-if="listData.cardType == 'GAME'"
        ></league-detail-card>
      </span>
      <span v-if="listData.cardType == 'PROGRAM' && listData.type !== 1">
        <program-more-card
          :cardData="programMoreCardData"
          :isFocusedLine="isFocusOn"
        ></program-more-card>
      </span>
      <span v-else-if="hasMoreCard">
        <home-more-card
          :cardData="moreCardData"
          :isFocusedLine="isFocusOn"
        ></home-more-card>
      </span>
      <template v-if="isRollingList()">
        <span v-for="(cardData, index) in listData.list" class="card" ref="card" :key="`rolling_card_${index}`">
          <home-live-card
            :cardData="cardData"
            :isFocusedLine="isFocusOn"
            :contentType="listData.type"
            v-if="isLiveVod"
          ></home-live-card>
          <home-vod-card
            :cardData="cardData"
            :isFocusedLine="isFocusOn"
            :contentType="listData.type"
            v-else-if="listData.cardType == 'HOME'"
          ></home-vod-card>
          <league-card
            :cardData="cardData"
            :isFocusedLine="isFocusOn"
            v-else-if="listData.cardType == 'LEAGUE'"
          ></league-card>
          <program-card
            :cardData="cardData"
            :isFocusedLine="isFocusOn"
            v-else-if="listData.cardType == 'PROGRAM'"
          ></program-card>
          <setting-card
            :cardData="cardData"
            :isFocusedLine="isFocusOn"
            v-else-if="listData.cardType == 'BUTTON'"
          ></setting-card>
          <league-detail-card
            :cardData="cardData"
            :isFocusedLine="isFocusOn"
            v-else-if="listData.cardType == 'GAME'"
          ></league-detail-card>
        </span>
        <span v-if="listData.type == '3' || listData.type == '4' || listData.type == '6'">
          <home-more-card 
            :cardData="moreCardData" 
            :isFocusedLine="isFocusOn"
          ></home-more-card>
        </span>
        <span v-else-if="hasMoreCard">
          <program-more-card
            :cardData="programMoreCardData"
            :isFocusedLine="isFocusOn"
          ></program-more-card>
        </span>
        <template v-for="(cardData, index) in listData.list">
          <span
            v-if="index < 2"
            class="card"
            ref="card"
            :key="`card_index_${index}`"
          >
            <home-live-card
              :cardData="cardData"
              :isFocusedLine="isFocusOn"
              :contentType="listData.type"
              v-if="isLiveVod"
            ></home-live-card>
            <home-vod-card
              :cardData="cardData"
              :contentType="listData.type"
              v-else-if="listData.cardType == 'HOME'"
            ></home-vod-card>
            <league-card
              :cardData="cardData"
              v-else-if="listData.cardType == 'LEAGUE'"
            ></league-card>
            <program-card
              :cardData="cardData"
              v-else-if="listData.cardType == 'PROGRAM'"
            ></program-card>
            <setting-card
              :cardData="cardData"
              v-else-if="listData.cardType == 'BUTTON'"
            ></setting-card>
            <league-detail-card
              :cardData="cardData"
              v-else-if="listData.cardType == 'GAME'"
            ></league-detail-card>
          </span>
        </template>
      </template>
    </div>
    <div
      v-if="mouseActivated && focusedIndex > 0"
      class="arrow-box left"
      @click="pageScroll('left')"
      @mouseover="mouseFocus = 'L'"
      @mouseleave="mouseFocus = ''"
      :style="arrowLeftStyleObject"
    >
      <img
        v-if="mouseFocus == 'L'"
        class="arrow"
        src="@/assets/button-remote-control-focuson-left.png"
      />
      <img v-else class="arrow" src="@/assets/button-remote-control-left.png" />
    </div>
    <div
      v-if="doPaging && mouseActivated"
      class="arrow-box right"
      @click="pageScroll('right')"
      @mouseover="mouseFocus = 'R'"
      @mouseleave="mouseFocus = ''"
      :style="arrowRightStyleObject"
    >
      <img
        v-if="mouseFocus == 'R'"
        class="arrow"
        src="@/assets/button-remote-control-focuson-right.png"
      />
      <img
        v-else
        class="arrow"
        src="@/assets/button-remote-control-right.png"
      />
    </div>
  </div>
</template>

<script>
import HomeVodCard from "../card/HomeVodCard.vue";
import HomeLiveCard from "../card/HomeLiveCard.vue";
import LeagueCard from "../card/LeagueCard.vue";
import SettingCard from "../card/SettingCard.vue";
import LeagueDetailCard from "../card/LeagueDetailCard.vue";
import ProgramCard from "../card/ProgramCard.vue";
import HomeMoreCard from "../card/HomeMoreCard.vue";
import ProgramMoreCard from "../card/ProgramMoreCard.vue";

export default {
  components: {
    HomeVodCard,
    HomeLiveCard,
    LeagueCard,
    SettingCard,
    LeagueDetailCard,
    ProgramCard,
    HomeMoreCard,
    ProgramMoreCard,
  },
  data() {
    return {
      left: 0,
      focusedIndex: 0,
      animationRunning: false,
      listClass: "slide",
      mouseFocus: "",
      animationRunningTimer: null
    };
  },
  props: ["listData", "focusedLine", "componentStyle", "isActiveVue"],

  computed: {
    moreCardData() {
      return {
        type: this.listData.type,
        name: this.listData.title,
        id: this.listData.destId,
        gameDesc: this.listData.list[0].gameDesc,
      };
    },
    programMoreCardData() {
      return {
        type: this.listData.type,
        name: this.listData.title,
        programId: this.listData.destId,
      };
    },
    listStyleObj() {
      return {
        width:
          (this.componentStyle.width.replace("px", "") + 25) *
            (this.maxIndex + 1) +
          "px",
        "margin-left": this.componentStyle.left,
      };
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    computedStyleObject() {
      return {
        left: this.left + "px",
      };
    },
    arrowLeftStyleObject() {
      return {
        top: this.componentStyle.height.replace("px", "") / 2 - 32 + "px",
      };
    },
    arrowRightStyleObject() {
      return {
        top: this.componentStyle.height.replace("px", "") / 2 - 32 + "px",
        left: Number(window.innerWidth) == 1920 ? 1920 - 64 - 11 - this.componentStyle.left.replace("px", "") + "px" : 1280 - 64 - 11 - this.componentStyle.left.replace("px", "") + "px",
      };
    },
    listLength() {
      if (this.hasMoreCard) {
        return this.listData.list.length + 1;
      } else {
        return this.listData.list.length;
      }
    },
    hasMoreCard() {
      if (
        this.listData.cardType == "HOME" &&
        (this.listData.type == "3" || this.listData.type == "4" || this.listData.type == "6")
      ) {
        return true;
      } else if (
        this.listData.cardType == "PROGRAM" &&
        this.listData.type !== 1
      ) {
        return true;
      }
      return false;
    },
    doPaging() {
      if (this.listData.cardType == "LEAGUE") {
        if (this.maxIndex >= 6 && this.maxIndex - this.focusedIndex >= 6) {
          return true;
        }
      } else if (this.listData.cardType == "PROGRAM") {
        if (this.maxIndex >= 4 && this.maxIndex - this.focusedIndex >= 4) {
          return true;
        }
      } else if (
        this.maxIndex >= 3 &&
        this.maxIndex - this.focusedIndex >= 3
      ) {
        return true;
      }
      return false;
    },
    maxIndex() {
      return this.isRollingList()
        ? this.listLength * 2 - 1
        : this.listLength - 1;
    },
    pageItemNum() {
      if (this.listData.cardType == "LEAGUE") {
        return 6;
      } else {
        return 3;
      }
    },
    mouseActivated() {
      return (
        this.$store.getters.mouseActivated &&
        this.focusedLine == this.listData.seqNo
      );
    },
    isFocusOn() {
      return this.focusedLine == this.listData.seqNo;
    },
    isLiveVod() {
      return (
        this.listData.cardType == "HOME" &&
        this.listData.type == 1 &&
        (this.listData.destId == 1 || this.listData.destId == 2)
      );
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (val.focusView == "default" && this.enableInput()) {
        switch (val.key) {
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
        }
      }
    },
    // focusedIndex(val, oldval) {
    //   this.left = this.getScrollPixsel() * val * -1;
    // },
  },

  methods: {
    moveFocus(index) {
      this.focusedIndex = index;
    },
    leftKeyProc(keyInput) {
      if (this.focusedIndex == 0) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      } else {
        this.setFocus(this.focusedIndex - 1);
      }
    },
    rightKeyProc(keyInput) {
      this.setFocus(this.focusedIndex + 1);
    },
    enterKeyProc(keyInput) {
      this.$children[this.focusedIndex].clickCard();
    },
    backKeyProc(keyInput) {
      this.$store.commit("SET_FOCUSED_VIEW", "gnb");
    },
    getScrollPixsel() {
      return this.$refs.card[0].offsetWidth;
    },
    isRollingList() {
      if (this.listData.cardType == "LEAGUE") {
        if (this.listLength > 6) {
          return true;
        }
      } else if (this.listData.cardType == "PROGRMA") {
        if (!this.hasMoreCard && this.listLength > 4) {
          return true;
        }
      } else if (!this.hasMoreCard && this.listLength > 3) {
        return true;
      }
      return false;
    },
    enableInput() {
      return (
        this.isActiveVue &&
        this.focusedLine == this.listData.seqNo && !this.animationRunning
      );
    },
    pageScroll(direction) {
      if (this.enableInput()) {
        this.animationRunning = true;
        if (direction == "left") {
          this.setFocus(this.focusedIndex - this.pageItemNum);
        } else {
          this.setFocus(this.focusedIndex + this.pageItemNum);
        }
      }
    },
    setFocus(index, justFocusing) {
      if (index < 0) {
        index = 0;
      } else if (index > this.maxIndex) {
        index = this.maxIndex;
      }

      if (this.focusedIndex == index) {
        return;
      }

      this.focusedIndex = index;

      if (!justFocusing) {
        this.animationRunning = true;
        this.left = this.getScrollPixsel() * this.focusedIndex * -1;
        
        // transitionend eventListener가 발생하지 않아 animationRunning 값이 false로 갱신 되지 않는 경우 방지
        this.animationRunningTimer = setTimeout(() => {
          clearTimeout(this.animationRunningTimer)
          this.animationRunningTimer = null
          this.animationRunning = false;
        }, 600)
      }
    },
  },
  mounted() {
    const self = this;
    self.animationRunning = false;

    this.$refs.list.addEventListener("transitionend", function (e) {
      e.stopPropagation();

      clearTimeout(self.animationRunningTimer)
      self.animationRunningTimer = null

      if (self.focusedIndex >= self.listLength) {
        self.listClass = "rolling";
        self.setFocus(self.focusedIndex - self.listLength);
        let timer = setTimeout(() => {
          clearTimeout(timer);
          self.listClass = "slide";
          self.animationRunning = false;
          clearTimeout(self.animationRunningTimer)
          self.animationRunningTimer = null
        }, 1);
      } else {
        self.animationRunning = false;
      }
    });
  },
};
</script>

<style scoped>
.list-main {
  padding-bottom: 10px;
}

.list-title {
  height: 38px;
  width: 1000px;
  padding-top: 40px;
  margin-bottom: 20px;
  font-size: 30px;
  font-weight: bold;
  color: #eeeeee;
}
.list-slider {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  background-color: "white";
}

.slide {
  transition-duration: 0.3s;
  /* transition-timing-function: linear; */
}
.rolling {
  transition-duration: 0;
}
.arrow-box {
  position: absolute;
  z-index: 6;
  top: 0px;
  width: 64px;
  height: 280px;
  text-align: center;
}
.arrow-box.left {
  left: -40px;
}
.arrow-box.right {
  /* right: 11px; */
}
.arrow {
  top: 100px;
  width: 64px;
  height: 64px;
}

.live {
  display: inline-block;
  width: 242.25px;
  height: 38px;
  background-image: url("~@/assets/bedge-live-title@2x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

@media all and (min-width:0px) and (max-width:1280px){
  .list-title {
    height: 56px;
    width: 1000px;
    padding-top: 32px;
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 24px;
  }

  .live {
    width: 153px;
    height: 24px;
  }
}
</style>